import { Button, Flex, Form, Input, Segmented, Typography } from 'antd'
import { StepProps } from '../types'
import { ContentWrapper } from '../components/ContentWrapper'
import { AudienceList } from '../components/AudienceList'
import { LoyaltyTierList } from '../components/LoyaltyTierList'
import { useCallback, useEffect, useState } from 'react'
import { userHasRoles } from '../../../HasAccess'
import { useAuth } from '../../../../modules/auth/contexts/Auth'
import { Admin } from '../../../../models/Admin'

const { Title } = Typography

type Props = StepProps & {
  viewOnly?: boolean
}

export const Audience = ({ onPrev, onNext, viewOnly = false }: Props) => {
  const { currentUser } = useAuth<Admin, {}>()
  const form = Form.useFormInstance()

  const audienceWatch = Form.useWatch('audience')
  const loyaltyTierWatch = Form.useWatch('loyaltyTier')

  const isMembershipAdmin = useCallback(() => {
    if (!currentUser) return false
    return userHasRoles(currentUser, [{ id: 0, name: 'membership' }])
  }, [currentUser])

  const [selectedTab, setSelectedTab] = useState<
    'defaultAudiences' | 'loyaltyTiers'
  >(isMembershipAdmin() ? 'loyaltyTiers' : 'defaultAudiences') // afin de mettre la bonne tab active lors de l'update d'une notification

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab as 'defaultAudiences' | 'loyaltyTiers')
    form.setFieldValue('audience', undefined)
    form.setFieldValue('loyaltyTier', undefined)
  }

  useEffect(() => {
    if (audienceWatch) {
      setSelectedTab('defaultAudiences')
    }
    if (loyaltyTierWatch) {
      setSelectedTab('loyaltyTiers')
    }
  }, [audienceWatch, loyaltyTierWatch])
  return (
    <>
      <ContentWrapper>
        <Title className="m-0" level={5}>
          Select your audience
        </Title>
        {!isMembershipAdmin() && (
          <Segmented
            value={selectedTab}
            onChange={handleTabChange}
            options={[
              { label: 'Segments', value: 'defaultAudiences' },
              { label: 'Loyalty Tiers', value: 'loyaltyTiers' },
            ]}
            block
          />
        )}
        {selectedTab == 'defaultAudiences' && (
          <AudienceList
            viewOnly={viewOnly}
            showOnlySubscribedCount
            pageSize={5}
          />
        )}
        {selectedTab == 'loyaltyTiers' && (
          <LoyaltyTierList viewOnly={viewOnly} />
        )}
        <Form.Item noStyle name={'audience'}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item noStyle name={'loyaltyTier'}>
          <Input type="hidden" />
        </Form.Item>
      </ContentWrapper>
      <Flex justify="flex-end" gap={8}>
        <Button type="default" onClick={onPrev} disabled={false}>
          Prev
        </Button>
        <Button
          type="primary"
          onClick={onNext}
          disabled={!audienceWatch && !loyaltyTierWatch}
        >
          Next
        </Button>
      </Flex>
    </>
  )
}
